export enum ProvidedStravaScope {
  'MAX' = 'MAX',
  'INSUFFICIENT' = 'INSUFFICIENT'
}
